// import React from "react";
// import YoutubeBackground from "react-youtube-background";
// const IntroTwo = () => {
//   return (
//     <YoutubeBackground
//       // videoId="yYNO29KQJy0"
//       aspectRatio={"16:10"}
//       videoId="Qj2WD-YkbFo"
//       overlay="rgba(0,0,0,.4)"
//       className="intro-section section bg-video"
//     >
//       <div className="container">
//         <div className="row row-cols-lg-1 row-cols-1">
//           <div className="col align-self-center">
//             <div className="intro-content-two text-center mt-xl-8 mt-lg-8 mt-md-8 mt-sm-8 mt-xs-8">
//               <h2 className="title">Revolutionizing Energy Solutions</h2>
//               <div className="desc">
//                 <p>
//                   {/* Tawanai EnergyTech provides expert renewable energy
//                   consultancy and solutions. We offer tailored strategies, from
//                   site prospecting to operational optimization.With global
//                   experience, we ensure efficient, sustainable power generation,
//                   making us a dependable, data-driven partner in renewable
//                   energy projects */}
//                   Tawanai EnergyTech provides expert renewable energy
//                   consultancy and solutions. We offer tailored strategies, from
//                   site prospecting to operational optimization. Our global
//                   experience ensures efficient and sustainable power generation,
//                   making us a dependable, data-driven partner in renewable
//                   energy projects
//                 </p>
//               </div>
//               {/* <Link
//                 to={process.env.PUBLIC_URL + "/"}
//                 className="btn btn-primary btn-hover-secondary"
//               >
//                 Get Started
//               </Link>
//               <Link
//                 to={process.env.PUBLIC_URL + "/"}
//                 className="btn btn-outline-white btn-hover-primary"
//               >
//                 {" "}
//                 Learn More{" "}
//               </Link> */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </YoutubeBackground>
//   );
// };

// export default IntroTwo;






import ReactPlayer from "react-player";
import HomeVideo from '../../pages/home.mp4'
const IntroTwo = () => {
  return (
    <section
      style={{
        position: "relative",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "#000",
      }}
    >
      {/* Video Background */}
      <ReactPlayer
        // url="https://youtu.be/Qj2WD-YkbFo"   // put mp4 in public/videos
        url={HomeVideo}
        playing
        muted
        loop
        width="100%"
        height="100%"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          objectFit: "cover",
          zIndex: 0,

        }}
        config={{
          file: {
            attributes: {
              playsInline: true,
            },
          },
        }}
      />

      {/* Dark Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.45)",
          zIndex: 1,
        }}
      />

      {/* Content */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "#ffffff",
          padding: "0 20px",
        }}
      >
        <div
          style={{
            maxWidth: "820px",
            margin: "0 auto",
          }}
        >
          {/* <h1
            style={{
              fontSize: "clamp(2.8rem, 5vw, 3.8rem)",
              fontWeight: "700",
              lineHeight: "1.2",
              marginBottom: "24px",
              letterSpacing: "-0.5px",
              color: "rgba(255,255,255,0.85)",
            }}
          >
            Revolutionizing <br /> Energy Solutions
          </h1> */}

          <h1
            style={{
              fontSize: "clamp(3.2rem, 5.5vw, 4.3rem)", // a little bigger
              fontWeight: "800",
              lineHeight: "1.15",
              marginBottom: "24px",
              letterSpacing: "-0.6px",

              // glassy look
              color: "rgba(255,255,255,0.95)",
              textShadow: "0 6px 30px rgba(0,0,0,0.35)",
              WebkitTextStroke: "1px rgba(255,255,255,0.12)",

              // subtle glow
              filter: "drop-shadow(0 0 18px rgba(255,255,255,0.10))",
            }}
          >
            Revolutionizing <br /> Energy Solutions
          </h1>

          <p
            style={{
              fontSize: "1.05rem",
              lineHeight: "1.8",
              color: "rgba(255,255,255,0.85)",
              maxWidth: "720px",
              margin: "0 auto",
            }}
          >
            Tawanai provides expert renewable energy consultancy and <br />
            solutions. We offer tailored strategies, from site prospecting to <br />
            operational optimization. Our global experience ensures efficient and <br />
            sustainable power generation, making us a dependable, data-driven <br /> partner
            in renewable energy projects.
          </p>
        </div>
      </div>
    </section>
  );
};

export default IntroTwo;